import React, {useRef, useEffect} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
// import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
// import {fetchSmartEngageDataThunk} from '@stencil/hotels-smartengage-store';
import {smartEngageSelector} from '@stencil/hotels-smartengage-store';
import SmartEngageUI from '../../../../stories/components/hotels/SRP/SmartEngageUI/SmartEngageUI';

// const intersectionObserverOptions = {
//   root: null,
//   threshHold: 0.01,
// };

const SmartEngageBanner: React.FC<{applyFilterCta: Function}> = ({applyFilterCta = () => {}}) => {
  // const dispatch = useDispatch();
  const {isLoading: isApiLoading, dataList: smartEngageDataList} = useSelector(smartEngageSelector);

  const smartEngageDataRef = useRef(smartEngageDataList);
  const isApiLoadingRef = useRef(isApiLoading);

  // const fetchSmartEngageDataThunkCaller = useCallback(() => {
  //   return dispatch(fetchSmartEngageDataThunk());
  // }, [dispatch]);

  // const [watcherRef] = useIntersectionObserver(intersectionObserverOptions, () => {
  //   if (
  //     !isApiLoadingRef.current &&
  //     // default value is an empty arrow hence below will always be true
  //     smartEngageDataRef.current &&
  //     !smartEngageDataRef.current.length
  //   ) {
  //     fetchSmartEngageDataThunkCaller();
  //   }
  // });

  useEffect(() => {
    smartEngageDataRef.current = smartEngageDataList;
    isApiLoadingRef.current = isApiLoading;
  }, [smartEngageDataList, isApiLoading]);

  const thereIsSmartEngageList = smartEngageDataRef.current && smartEngageDataRef.current.length;

  return (
    // <div ref={watcherRef}>

    <div>
      <SmartEngageBannerWrap>
        {(isApiLoading && null) ||
          (thereIsSmartEngageList && (
            <SmartEngageUI dataList={smartEngageDataRef.current} applyFilterCta={applyFilterCta} />
          )) ||
          null}
      </SmartEngageBannerWrap>
    </div>
  );
};

export default SmartEngageBanner;

const SmartEngageBannerWrap = styled.div(
  props => `
  position:relative;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  `,
);
